<template>
  <div>
    YOU FOUND THE HIDDEN BUNNY?!?!?!?
  </div>
</template>
<script>
export default {
  name: "ProfileTabHiddenBunny"
};
</script>